import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLeads, setLeadsList, setTemplateList, setNumbersList, setCurrentPhoneNumber, setPaymentInfo, clearLeads } from '@Redux/kaiziqLeads/kaiziqLeadsAction';

export const useReduxLeads = () => {

    const dispatch = useDispatch();

    const leads = useSelector((state) => state.leads.currentLeads);
    const leadsList = useSelector((state) => state.leads.leadsList);
    const templateListValue = useSelector((state) => state.leads.templateList);
    const numbersListValue = useSelector((state) => state.leads.numbersList);
    const currentPhoneNumberValue = useSelector((state) => state.leads.currentPhoneNumber);
    const paymentInfo = useSelector((state) => state.leads.paymentInfo);
    const leadsId = leads?.id ?? 0;
    const advanceProtectionObj = !!leads?.details ? leads?.details?.advanceProtection : { whatsappFlowProtection: false, templateProtection: false, campaignProtection: false };
    const whatsappFlowProtection = advanceProtectionObj?.whatsappFlowProtection;
    const templateProtection = advanceProtectionObj?.templateProtection;
    const campaignProtection = advanceProtectionObj?.campaignProtection;
    const advanceProtection = (whatsappFlowProtection || templateProtection || campaignProtection) ?? false;

    const setLeadsValue = useCallback(
        async (leadsData) => {
            leadsData.details = !!leadsData.details ? (typeof leadsData.details === 'string' ? JSON.parse(leadsData.details) : leadsData.details) : {};
            dispatch(setLeads(leadsData))
        },
        [dispatch]
    );

    const setLeadsListValue = useCallback(
        async (leadsListData) => {
            dispatch(setLeadsList(leadsListData))
        },
        [dispatch]
    );

    const setTemplateValue = useCallback(
        async (templateData) => {
            dispatch(setTemplateList(templateData))
        },
        [dispatch]
    );

    const setNumbersValue = useCallback(
        async (numbersData) => {
            dispatch(setNumbersList(numbersData))
        },
        [dispatch]
    );

    const setCurrentPhoneNumberValue = useCallback(
        async (phoneNumber) => {
            let leadsData = leadsList.find((item) => item.id === phoneNumber?.leadsId);
            if (!!leadsData) {
                setLeadsValue(leadsData);
            }
            dispatch(setCurrentPhoneNumber(phoneNumber))
        },
        [dispatch]
    );

    const setCurrentLeadsPaymentInfo = useCallback(
        async (paymentInfo) => {
            dispatch(setPaymentInfo(paymentInfo))
        },
        [dispatch]
    );

    const clearLeadsValue = useCallback(
        () => {
            dispatch(clearLeads())
        },
        [dispatch]
    );

    return {
        currentLeads: leads,
        currentLeadsId: leadsId,
        advanceProtection,
        whatsappFlowProtection,
        templateProtection,
        campaignProtection,
        currentPhoneNumber: currentPhoneNumberValue,
        leadsList: leadsList,
        setLeadsList: setLeadsListValue,
        templateList: templateListValue,
        numbersList: numbersListValue,
        setCurrentLeads: setLeadsValue,
        setTemplateList : setTemplateValue,
        setNumbersList : setNumbersValue,
        setPhoneNumber : setCurrentPhoneNumberValue,
        leadsPaymentInfo: paymentInfo,
        setCurrentLeadsPaymentInfo: setCurrentLeadsPaymentInfo,
        clearLeads: clearLeadsValue,
    };
};


